// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"873":"4a5415eb","890":"ab8f4e37","906":"b8074e6b","970":"05ab19c1"}[chunkId] + ".js";
};